import {Mapper} from '@s-ui/domain'

export class RawParamsToGetRecommendedPriceRequestSellerMapper extends Mapper {
  constructor({getRecommendedPriceRequestFactory, invalidRequestSellerErrorFactory, toQueryString}) {
    super()

    this._getRecommendedPriceRequestFactory = getRecommendedPriceRequestFactory
    this._invalidRequestSellerErrorFactory = invalidRequestSellerErrorFactory
    this._toQueryString = toQueryString
  }

  validate = requestFields => {
    const hasEmptyFields = Object.values(requestFields).some(requestField => !requestField)

    if (hasEmptyFields) throw this._invalidRequestSellerErrorFactory('All fields are required')
  }

  map = requestFields => {
    const {bodyTypeDoors, fuelId, km, makeId, modelId, transmissionTypeId, versionId, year} = requestFields

    this.validate({
      bodyTypeDoors,
      fuelId,
      km,
      makeId,
      modelId,
      transmissionTypeId,
      versionId,
      year
    })

    const [bodyTypeId, doors] = bodyTypeDoors.split('-')

    const queryParams = this._toQueryString({
      bodyTypeId,
      doors,
      fuelId,
      makeId,
      mileage: km,
      modelId,
      transmissionTypeId,
      versionId,
      year
    })

    return this._getRecommendedPriceRequestFactory({queryParams})
  }
}
